import React from "react";

function Stats() {
  return (
    <div className="phone-stats-container">
      <div className="inventory-title">STATS</div>
      <div className="inventory-stats">
        <div className="inventory-stats-item">0000</div>
        <div className="inventory-stats-item">0000</div>
        <div className="inventory-stats-item">0000</div>
      </div>
    </div>
  );
}

export default Stats;
